import { useEffect, useMemo } from "react";
import { useAvailableLinesStore } from "../../stores/hashs/useAvailableLinesStore";
import { useLinesStore } from "../../stores/useLinesStore";
import { useClientsStore } from "../../stores/useClientsStore";
import { useAuthStore } from "../../stores/useAuthStore";

export function useAvailableLines() {

    const linhasDisponiveis = useLinesStore(state => state.linhasDisponiveis);
    const allowLinhas = useLinesStore(state => state.allowLinhas);
    const sentidosSet = useLinesStore(state => state.sentidosSet);
    const allowClientes = useClientsStore(state => state.allowClientes);
    const allowPerfis = useAuthStore(state => state.allowPerfis);

    const setAvailableLines =
        useAvailableLinesStore(
            state => state.setAvailableLines
        );

    const value = useMemo(() => {

        const data = [];
        let totalToday = 0;
        let totalNext = 0;

        for (const linha of linhasDisponiveis) {

            if (!sentidosSet.has(linha.SENTIDO)) continue;

            const codigo = String(linha.CODIGO_INTEGRACAO);

            if (allowLinhas && !allowLinhas.has(codigo)) continue;
            if (allowClientes && !allowClientes.has(String(linha.client_id))) continue;
            if (!allowPerfis.has(Number(linha.unidade_opera))) continue;

            data.push(linha);

            if (linha.today) totalToday++;
            if (linha.next) totalNext++;

        }

        const total = data.length;

        return {
            data,
            total,
            totalToday,
            totalNext,
            title:
                `LINHA${total > 1 ? 'S' : ''} ${
                    total > 1
                        ? 'DISPONÍVEIS'
                        : 'DISPONÍVEL'
                }`
        };

    }, [
        linhasDisponiveis,
        sentidosSet,
        allowLinhas,
        allowClientes,
        allowPerfis
    ]);

    useEffect(() => {

        setAvailableLines(value);

    }, [
        value,
        setAvailableLines
    ]);

}